import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";
import { AppUpdate } from "@capawesome/capacitor-app-update";

export const PLAY_URL = "https://play.google.com/store/apps/details?id=in.toletbook.app";

export async function getAppInfo(): Promise<{ version: string; build: number } | null> {
  if (!Capacitor.isNativePlatform()) return null;
  try {
    const i = await App.getInfo();
    return { version: i.version, build: Number(i.build) || 0 };
  } catch {
    return null;
  }
}

// Opens ToLetBook's own page in the Play Store (the app, or the website
// when this is not the Android app).
export async function openPlayListing(): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    try {
      await AppUpdate.openAppStore();
      return;
    } catch {
      // fall through to the web link
    }
  }
  window.open(PLAY_URL, "_blank", "noopener");
}

// People who rate us 4 or 5 stars land on ToLetBook's Play Store page, where
// the rating screen is one tap away.
export async function requestPlayReview(): Promise<void> {
  await openPlayListing();
}
